/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

// import HistoryProject from '../child/history-project';
import { accountManagement } from '@/api/ajax';
import mainAccountModification from '../child/mainAccountModification.vue';
import roleAction from '../child/roleAction';
import authAction from '../child/authAction.vue';
import AccountAction from '../child/accountAction.vue';
import SubAccountLog from '../child/subAccountLog.vue';
import MainAccountLog from '../child/mainAccountLog.vue';

export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  subAccountName: {
    label: '子账号',
    prop: 'userName'
  },
  mainAccountName: {
    label: '登录账号',
    prop: 'loginName'
  },
  password: {
    label: '登录密码',
    prop: 'password',
    render: (h, ctx, row) => {
      const mainAccountModificationFn = () => {
        ctx.parent.$xrkDialog({
          title: '修改登录密码',
          width: '510px',
          showConfirm: false,
          showCancel: false,
          cancelType: 'primary',
          cancelText: '关闭',
          $slots: {
            default: h(mainAccountModification, {
              props: {
                phone: row.phone,
                modificationType: 1,
                authPeople: row.authPeople
              }
            })
          }
        });
      };
      return (
        <div>
          <span>******</span>
          <el-button
            onClick={mainAccountModificationFn}
            style="margin-left:5px"
            type="text"
            size="mini"
          >
            修改
          </el-button>
        </div>
      );
    }
  },
  authPeople: {
    label: '经办人',
    prop: 'authPeople',
    render: (h, ctx, row) => {
      // const mainAccountModificationFn = () => {
      //   ctx.parent.$xrkDialog({
      //     title: '修改经办人',
      //     width: '50%',
      //     showConfirm: false,
      //     showCancel: false,
      //     cancelType: 'primary',
      //     cancelText: '关闭',
      //     $slots: {
      //       default: h(mainAccountModification, {
      //         props: {
      //           phone: row.phone,
      //           modificationType: 2,
      //           authPeople: row.authPeople
      //         }
      //       })
      //     }
      //   });
      // };
      return (
        <div>
          <span>{row.authPeople}</span>
          {/* <el-button
            onClick={mainAccountModificationFn}
            style="margin-left:5px"
            type="text"
            size="mini"
          >
            修改
          </el-button> */}
        </div>
      );
    }
  },
  authPeoplePhone: {
    label: '经办人手机号',
    prop: 'phone'
  },
  lastLoginTime: {
    label: '最后登录时间',
    prop: 'lastLoginTime'
  },
  ip: {
    label: '上次登录IP',
    prop: 'ip'
  },
  fullName: {
    label: '姓名',
    prop: 'fullName'
  },
  phone: {
    width: '180px',
    label: '联系方式',
    prop: 'phone',
    formatter: i => {
      return i.phone.replace(/^(.{3})(.*)(.{4})$/, '$1 $2 $3');
    }
  },
  roleName: {
    label: '角色',
    prop: 'roleName'
  },
  department: {
    label: '部门',
    prop: 'department',
    formatter: row => {
      return row.department || '-';
    }
  },
  position: {
    label: '职位',
    prop: 'position',
    formatter: row => {
      return row.position || '-';
    }
  },
  createDt: {
    label: '创建时间',
    prop: 'createDt'
  },
  auth: {
    width: '100px',
    label: '权限',
    prop: 'historyProject',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let showDialog = () => {
        vm.$xrkDialog({
          title: '权限',
          width: '50%',
          showConfirm: false,
          cancelType: 'primary',
          cancelText: '关闭',
          $slots: {
            default: h(authAction, {
              props: {
                userId: row.userId
              }
            })
          }
        });
      };
      return (
        <el-button type="text" onClick={showDialog}>
          查看
        </el-button>
      );
    }
  },
  status: {
    width: '100px',
    label: '启用状态',
    prop: 'status',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let statusText = row.status === 1 ? '停用' : '启用';
      let statusChange = () => {
        vm.$xrkDialog({
          title: '启用状态',
          width: '40%',
          showCancel: true,
          showConfirm: true,
          confirmText: '确认',
          success(params) {
            if (params.confirm) {
              accountManagement
                .status({
                  userId: row.userId,
                  type: 2,
                  status: row.status === 1 ? 2 : 1
                })
                .then(() => {
                  vm.$message.success(`${statusText}成功`);
                  vm.$xrkDialog.remove();
                  vm.reGetPage();
                });
            }
          },
          $slots: {
            default: vm.$createElement(roleAction, {
              props: {
                actionType: 3,
                customText:
                  row.status === 1
                    ? '您是否要停用当前子账号？停用后，该子账号将无法再登录系统。请确认'
                    : '您是否要启用当前子账号？启用后，该子账号将可继续登录系统进行操作。'
              }
            })
          }
        });
      };
      return (
        <el-button
          disabled={row.logoutStatus == 1}
          style={row.status !== 1 ? 'color:red' : ''}
          type="text"
          onClick={statusChange}
        >
          {row.status !== 1 ? '停用' : '启用'}
        </el-button>
      );
    }
  },
  operate: {
    width: '200px',
    label: '操作',
    prop: 'historyProject',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let statusText =
        row.logoutStatus === 0
          ? '注销'
          : row.logoutStatus === 1
          ? '取消注销'
          : '';
      let modifySubAccount = () => {
        sessionStorage.setItem('currentUserId', row.userId);
        vm.$xrkDialog({
          title: '编辑账号',
          width: '80%',
          showCancel: false,
          showConfirm: false,
          $slots: {
            default: vm.$createElement(AccountAction, {
              props: { actionType: 2, userId: row.userId, defaultValue: row },
              on: {
                confirm: () => {
                  vm.reGetPage();
                }
              }
            })
          }
        });
      };
      let logoutAccount = () => {
        vm.$xrkDialog({
          title: '注销',
          width: '45%',
          showCancel: true,
          showConfirm: true,
          success(params) {
            if (params.confirm) {
              accountManagement
                .logout({
                  userId: row.userId,
                  type: 2
                })
                .then(() => {
                  vm.$message.success(`${statusText}操作成功`);
                  vm.$xrkDialog.remove();
                  vm.reGetPage();
                });
            }
          },
          $slots: {
            default: vm.$createElement(roleAction, {
              props: {
                actionType: 3,
                // customText: `您是否要注销当前子账号？\n
                //   注销子账号将有10天冷静期，在此期间子账号将处于停用状态，且无法恢复为启用状态。
                //   10天冷静期过后，该子账号将被注销，且永久无法恢复。
                //   冷静期期间。您可随时取消注销子账号`
                customHTML: `<div>
                <div style="font-weight:700;margin:20px 0">
                您是否要注销当前子账号？
                </div>
                <div style="margin:20px 0">
                注销子账号将有10天冷静期，在此期间子账号将处于停用状态，且无法恢复为启用状态。
                10天冷静期过后，该子账号将被注销，且永久无法恢复。
                </div>
                <div style="margin:20px 0">
                冷静期期间。您可随时取消注销子账号。
                </div>
                </div>`
              }
            })
          }
        });
      };
      let logoutCancelAccount = () => {
        vm.$xrkDialog({
          title: '注销',
          width: '45%',
          showCancel: true,
          showConfirm: true,
          success(params) {
            if (params.confirm) {
              accountManagement
                .cancelLogout({
                  userId: row.userId,
                  type: 2
                })
                .then(() => {
                  vm.$message.success(`${statusText}操作成功`);
                  vm.$xrkDialog.remove();
                  vm.reGetPage();
                });
            }
          },
          $slots: {
            default: vm.$createElement(roleAction, {
              props: {
                actionType: 3,
                customHTML: `<div>
                <div style="font-weight:700;margin:20px 0">
                您是否要取消注销当前子账号？
                </div>
                <div style="margin:20px 0">
                取消后，该子账号将自动被重新启用。请您确认！
                </div>

                </div>`
              }
            })
          }
        });
      };
      return (
        <div>
          <el-button
            disabled={row.logoutStatus == 1}
            type="text"
            onClick={modifySubAccount}
          >
            修改
          </el-button>
          <el-button
            type="text"
            onClick={
              row.logoutStatus === 0 ? logoutAccount : logoutCancelAccount
            }
          >
            {row.logoutStatus === 0 ? (
              '注销'
            ) : row.logoutStatus === 1 ? (
              <div>
                <div>取消注销</div>
                <div style="font-size:12px">
                  剩余{row.logoutStatusDay || '0'}天
                </div>
              </div>
            ) : (
              ''
            )}
          </el-button>
        </div>
      );
    }
  },

  //-----log----//
  logAction: {
    label: '操作',
    prop: 'logDescription'
    // render: (h, ctx, row) => {
    //   // return <div>{logType[row.logType]}</div>;
    //   return row.logDescription;
    // }
  },
  happendDt: {
    label: '发生时间',
    prop: 'createDt'
  },
  remarks: {
    label: '说明',
    prop: 'remarks',
    render: (h, ctx, row) => {
      let vm = ctx.parent;
      const showDetail = () => {
        vm.$xrkDialog({
          title: '详情',
          width: '65%',
          showCancel: true,
          cancelText: '关闭',
          showConfirm: false,
          $slots: {
            default: vm.$createElement(MainAccountLog, {
              props: { id: row.id, type: row.logType },
              on: {
                confirm: () => {
                  vm.reGetPage();
                }
              }
            })
          }
        });
      };
      return (
        <div>
          <span>{row.remarks}</span>
          {[2, 3, 11].includes(row.logType) && (
            <el-button onClick={showDetail} type="text" size="mini">
              详情
            </el-button>
          )}
        </div>
      );
    }
  },
  created: {
    label: '创建时间',
    prop: 'created'
  },
  // lastLoginTime:{
  //   label: '最后登录时间',
  //   prop: 'lastLoginTime'
  // },
  lastOperationTime: {
    label: '最后操作时间',
    prop: 'lastOperationTime'
  },
  opearte: {
    label: '操作',
    render: (h, ctx, row) => {
      let vm = ctx.parent;
      let showSubAccountLog = () => {
        vm.$xrkDialog({
          title: '查看',
          width: '65%',
          showCancel: true,
          cancelText: '关闭',
          showConfirm: false,
          $slots: {
            default: vm.$createElement(SubAccountLog, {
              props: { subAccountNumberId: row.subAccountNumberId },
              on: {
                confirm: () => {
                  vm.reGetPage();
                }
              }
            })
          }
        });
      };
      return (
        <div>
          <el-button onClick={showSubAccountLog} type="text" size="mini">
            查看
          </el-button>
        </div>
      );
    }
  }
};
